/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback,  } from 'react';
import Pagination from '../../../components/Pagination';
import EmptyAddScreen from '../../../components/EmptyAddScreen'
import 'tw-elements';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import CardHeader from '../../../components/CardHeader';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow'
import GlobalContext from '../../../components/Context/GloablContext';
import { InventoryListData } from './InventoryListSlice';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import Table from './Components/Table';
import S3UploadHook from '../../../CommonMethods/S3UploadHook';
import Debounce from '../../../CommonMethods/Debounce';
import Toast from '../../../components/Toast';

const InventoryList = () => {
    const { setToastmessage } = useContext(GlobalContext);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const dispatch = useDispatch();
    const InventoryList = useSelector(state => state.InventoryListSlice);
    const { List } = InventoryList
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1, status: "active", filter : "true"});
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [progressCount, setprogressCount] = useState(0)
    const navigate = useNavigate();
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [threeDottedButtonLoading, setThreeBottedButtonLoading] = useState(false)
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        // setLoading(true);
        // setSearchParams({ page_number:  1 })
        getInstitutionUsers()
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getInstitutionUsers = useCallback(async () => {
        try {
            setLoading(true);
            const branch_id = await GetBranchId()
            const body = `${
                searchParams.get("page_number") === null ? "" : `&page_number=${searchParams.get("page_number")}`}${
                searchParams.get("limit") === null ? "" : `&limit=${searchParams.get("limit")}`}${
                searchParams.get("filter") === null ? "" : `&filter=${searchParams.get("filter")}`}${
                searchParams.get("status") === null ? "" : `&status=${searchParams.get("status")}`}${
                searchParams.get("search") === null ? "" : `&search=${searchParams.get("search")}`}`
            dispatch(InventoryListData(`inventory?branch_id=${branch_id}${body}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.all_total_count === 0 && searchParams.get('apply_filter')=== null ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found.");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            handleLoadData()
            console.error(error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.apply_filter = true
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /* `useEffect(() => { getInstitutionUsers(); }, [getInstitutionUsers]);` is a hook that is used to run
    the `getInstitutionUsers` function whenever the `getInstitutionUsers` function changes. In this case,
    the `getInstitutionUsers` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getInstitutionUsers` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        if(searchParams.get("limit") !== null && (searchParams.get("status") !== "active" && searchParams.get("status") !== "inactive")) {
            navigate("/404")
        }
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        getInstitutionUsers();
    }, [searchParams]);

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`users/reset-password/${confirmationState.item.email_address}`:`users/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }else{
                body={
                    "status":confirmationState.status==='Deactivate'?false:true,
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            if(confirmationState.status === 'Reset Password'){
                setToastmessage('Reset password email sent successfully')
            } else{
                setToastmessage(`Institution user ${state} successfully`);
            }
            handleConformationClick();
            // setLoading(true)
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            // setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    /**
     * The function `handleFilters` updates the search parameters based on the key-value pair provided
     * and sets the loading state to true.
     */
    const handleFilters = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.filter = true
        params.apply_filter = true
        if(key === 'all'){
            delete params['filter'];
            delete params['status'];
        } 
        else params[key] = value
        setSearchParams({ ...params})
    }
    /**
     * The function `handleImportFile` is an asynchronous function that handles the import of a file,
     * uploads it to an S3 bucket, and then makes a POST request to a server endpoint with the S3 URL.
     */
    async function handleImportFile(e) {
        let file = e.target.files[0];
        let url = ''
        if (file.name && file.type) {
            const branch_id = await GetBranchId()
            url = await S3UploadHook(file, `inventory/${branch_id}/${file.name}`, setprogressCount, true);
            let body = {
                s3_key: url
            }
            try {
                setThreeBottedButtonLoading(true)
                const importresponse = await dataService.PostAPI(body, `inventory/upload`)
                setToastmessage(importresponse?.data?.data?.message)
                e.target.value = null;
                setLoading(true);
                getInstitutionUsers()
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                setThreeBottedButtonLoading(false)
            } finally {
                setThreeBottedButtonLoading(false)
            }
        }
        e.target.value = null;
    }
    const handleThreeDottedButton = (e) => {
        if(e.target.id === "Sample Upload File") {
            try {
                window.open(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.ap-south-1.amazonaws.com/public/inventories/sample_file_download/bulk_upload_inventory.xlsx`, '_blank');
                // getStudentsDirectory()
                setToastmessage("Sample file downloaded successfully");
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            }
        } else if(e.target.id !== "Issue Inventory") {
            handleImportFile(e)
        }
    }
    return (
        <>
            <CardHeader noPadding >
                <TopBarWithShadow
                    AddButton={true}
                    SearchInput={true}
                    Tittle={'Inventory'}
                    AddButtonName={'Add Inventory'}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}
                    isClick='/inventory-master/inventory-list/add-inventory'
                    status={searchParams.get('status')}
                    handleFilters={handleFilters}
                    threeDottedButton={true}
                    handleThreeDottedButton={handleThreeDottedButton}
                    threeDottedButtonLoading={threeDottedButtonLoading}
                    customSearchPlaceHolder={`Item Name / Code`}
                    filterFromPage={'Inventory'}
                    statusBarList={['Active','Inactive']}
                />
                <div className='mainDataCntnrListDiv scrollBlue_thick'>
                    {loading ? <ItemShimmer />
                        :<>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                setLoading={setLoading}
                                getListData={getInstitutionUsers}
                                setToastErrorMessage={setToastErrorMessage}
                            />
                            {(List.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </>
                    }
                </div>
                {toastErrorMessage!=='' &&<Toast 
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Institution User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for this user ?` : `${confirmationState.status} ${confirmationState.item.first_name} ${confirmationState.item.last_name} ?`}`}
                        buttonName = {confirmationState.status === 'Reset Password' ? "Reset" : confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default InventoryList;
